import React, { ButtonHTMLAttributes } from 'react';
import { BoxProps, Tab as BaseTab, forwardRef, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { rgba } from 'polished';
import { rem } from 'utils/fonts';

const StyledTab = styled(BaseTab)`
  height: 36px;
  font-size: ${rem(14)};
  font-weight: 500;
  border-left: none;

  &:first-of-type {
    border-top-left-radius: 35px;
    border-bottom-left-radius: 35px;
  }

  &:last-of-type {
    border-top-right-radius: 35px;
    border-bottom-right-radius: 35px;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Props = BoxProps & ButtonHTMLAttributes<any>;

// eslint-disable-next-line react/display-name
const Pill = forwardRef<Props, 'button'>(({ children, ...props }, ref) => {
  const { colors } = useTheme();
  return (
    <StyledTab
      ref={ref}
      color={rgba(colors.pink[500], 0.5)}
      border={`1px solid ${colors.pink[500]}`}
      _selected={{ color: 'white', backgroundColor: 'pink.500' }}
      fontFamily="body"
      sx={{
        '&:first-of-type': {
          borderLeft: `1px solid ${colors.pink[500]}`,
        },
      }}
      {...props}
    >
      {children}
    </StyledTab>
  );
});

export default Pill;
